import { IParsedHtml } from './interfaces/parsedHtml';
import { PatternsConverter } from './PatternsConverter';
import { HtmlNodesHelper } from './HtmlNodesHelper';
import { IPartialChildNodeWithIndex } from './interfaces/patternsHtmlTags.interface';

export class PatternsParser {
  private converter: PatternsConverter;
  private htmlNodes: IPartialChildNodeWithIndex[];

  constructor(htmlNodes: NodeListOf<ChildNode>) {
    this.htmlNodes = HtmlNodesHelper.convertToPartialWithIndex(htmlNodes);
    this.converter = new PatternsConverter(this.htmlNodes);
  }

  parse(): IParsedHtml[] {
    if (!this.htmlNodes) return [];
    const parsedHtml = [];

    let parsingIndex = 0;
    while (parsingIndex < this.htmlNodes.length) {
      const { parsed, jumpIndexCount } = this.converter.convert(parsingIndex);
      if (parsed) parsedHtml.push(parsed);
      parsingIndex += jumpIndexCount;
    }

    return parsedHtml;
  }
}
